const LAYOUTS = {
  DASHBOARD: '/dashboard',
  PROGRAMS: '/programs',
  VPP: '/vpp',
  REPORTS: '/reports',
  DEVELOPER: '/developer',
  ADMIN: '/admin',
  NEWS: '/news'
}

const MICROSERVICES = {
  PROGRAMMANAGER: 'programs-mgr',
  SITEMANAGER: 'site-mgr',
  DISPATCHMANAGER: 'dispatch-mgr',
  ENROLLMENTMANAGER: 'enrollment-mgr',
  SESSIONMANAGER: 'session-mgr',
  VPPMANAGER: 'vpp-mgr',
  REPORTMANAGER: 'reports-mgr',
  TELEMETRYMANAGER: 'telemetry-mgr',
  CSIP: 'csip',
  OPENADR: 'openadr'
}

const COMMON = {
  CLICKAWAY: 'clickaway',
}

const SORTORDER = {
  ASC: 'ascending',
  DESC: 'descending'
}

export {
  LAYOUTS,
  MICROSERVICES,
  COMMON,
  SORTORDER
}